import React from 'react';
import { useTranslation } from 'react-i18next';
import { Regions } from '../../hooks/useConfiguration';
import { assertNever } from '../../utils/assertNever';
import { Representatives } from './representatives';
import { Contact } from './contact';

export const ContactsList: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t } = useTranslation();

  switch (region) {
    case 'us':
      return (
        <div className='contacts-list'>
          <div className='contacts-list__item'>
            <Representatives region={region} />
          </div>
          <div className='contacts-list__item'>
            <Contact region={region} />
          </div>
        </div>
      );
    case 'eu':
      return (
        <div className='contacts-list'>
          <div className='contacts-list__item'>
            <Representatives region={region} />
          </div>
          <div className='contacts-list__item'>
            <Contact region={region} />
          </div>
          <div className='contacts-list__item'>
            <h3 className='contacts-list__title'>{t('imprint.contactsList.court.title')}</h3>
            <div className='contacts-list__text'>
              {t('imprint.contactsList.court.text')}
              <br />
              HR B 8678
            </div>
          </div>
          <div className='contacts-list__item'>
            <h3 className='contacts-list__title'>{t('imprint.contactsList.vat.title')}</h3>
            <div className='contacts-list__text'>
              {t('imprint.contactsList.vat.text')}
              <br />
              DE 118051598
            </div>
          </div>
        </div>
      );
    default:
      assertNever(region);
  }
};
